<div id="notfound">
    <div class="notfound">
        <div class="notfound-404">
            <h1>Oops!</h1>
            <h2>404 - Page introuvable</h2>
        </div>
        <a [routerLink]="['/dashboard/home']">Revenir à l'accueil</a>
    </div>
</div>
